import { action } from 'satcheljs';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';

export const preloadTimePanelData = action('PRE_LOAD_TIME_PANEL_DATA');

export const toggleConflictsView = action(
    'TOGGLE_TIME_PANEL_CONFLICT_VIEW',
    (meeting: MeetingRequestMessageType) => ({ meeting })
);
